import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import VideoCard from './VideoCard';
import {
  WelcomeMat,
  WelcomeMatTile,
  Icon,
  Button,
  Checkbox
} from '@salesforce/design-system-react';

import './WelcomeMatContainer.scss';

export class WelcomeMatContainer extends Component {
  componentDidMount() {
    this.props.actions.initWelcomeMatStatus(this.props.name);
  }

  componentDidUpdate(prevProps) {
    if (this.props.welcomeMat.shouldOpen !== prevProps.welcomeMat.shouldOpen) {
      if (this.props.welcomeMat.shouldOpen) {
        this.props.actions.openModal(this.props.name);
      }
    }
  }

  handleClose() {
    this.props.actions.closeWelcomeMat(this.props.name);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals[this.props.name]?.isOpen || false;

    const videoLink = formatMessage({
      id: 'components.ecs.welcomeMat.videoLink'
    });

    const tiles = [
      {
        id: 'einstein-tile-asset-files',
        iconName: 'file',
        title: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.assetFiles.title'
        }),
        description: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.assetFiles.description'
        })
      },
      {
        id: 'einstein-tile-content-block',
        iconName: 'einstein',
        title: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.contentBlock.title'
        }),
        description: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.contentBlock.description'
        })
      },
      {
        id: 'einstein-tile-profiles',
        iconName: 'people',
        title: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.profile.title'
        }),
        description: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.profile.description'
        })
      },
      {
        id: 'einstein-tile-rules',
        iconName: 'formula',
        title: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.rules.title'
        }),
        description: formatMessage({
          id: 'components.ecs.welcomeMat.tiles.rules.description'
        })
      }
    ];
    return (
      <WelcomeMat
        className="einstein-welcome-mat"
        labels={{
          title: formatMessage({
            id: 'components.ecs.welcomeMat.title'
          }),
          description: formatMessage({
            id: 'components.ecs.welcomeMat.description'
          })
        }}
        doNotShowAgainCheckbox={
          <Checkbox
            assistiveText={{
              label: formatMessage({
                id: 'components.ecs.welcomeMat.dontShow'
              })
            }}
            id="dont-show"
            labels={{
              label: formatMessage({
                id: 'components.ecs.welcomeMat.dontShow'
              })
            }}
            onChange={() =>
              this.props.actions.updateWelcomeMat(
                !this.props.welcomeMat.shouldOpen,
                this.props.name
              )
            }
          />
        }
        onRenderInfoActions={() => (
          <Button
            key="welcomeMatSave"
            variant="brand"
            label={formatMessage({
              id: 'components.ecs.welcomeMat.getStarted'
            })}
            onClick={() => this.handleClose()}
          />
        )}
        isOpen={isOpen}
        onRequestClose={() => this.handleClose()}
        dismissOnClickingOutside={false}
        variant="info-only"
      >
        <VideoCard
          source={videoLink}
          title={formatMessage({
            id: 'components.ecs.welcomeMat.getStarted'
          })}
        />

        {tiles.map(tile => {
          return (
            <WelcomeMatTile
              key={tile.id}
              title={tile.title}
              description={tile.description}
              icon={<Icon category="utility" name={tile.iconName} />}
            />
          );
        })}
      </WelcomeMat>
    );
  }
}

WelcomeMatContainer.propTypes = {
  welcomeMat: PropTypes.shape({
    shouldOpen: PropTypes.bool
  }),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  name: PropTypes.string,
  modals: PropTypes.object,
  actions: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(WelcomeMatContainer);
